export default __webpack_public_path__ + "static/media/stadium.c90bc3b9.png";